import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import classnames from 'classnames';
import at from 'lodash/at';
import keys from 'lodash/keys';
import { getUiOptions } from 'react-jsonschema-form/lib/utils';

import BaseObjectField from './BaseObjectField';
import { withStyles } from 'material-ui/styles';
import Collapse from 'material-ui/transitions/Collapse';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';

const styles = theme => ({
  container: {
    '&:first-of-type': {
      marginTop: theme.spacing.unit * 2,
    },
    '&:last-of-type': {
      marginBottom: theme.spacing.unit * 2,
      borderBottom: `2px solid ${theme.palette.primary[500]}`,
    },
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  header: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    cursor: 'pointer',
    color: theme.palette.primary[500],
    borderTop: `2px solid ${theme.palette.primary[500]}`,
    minHeight: 48,
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  countComplete: {
    color: theme.palette.primary[500],
  },
  flex: {
    flex: 1,
  },
});

class AccordionComponent extends Component {
  state = { expanded: false };

  onExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const {
      classes,
      schema,
      errorSchema,
      formContext,
      uiSchema,
      options = getUiOptions(uiSchema),
      name,
      children,
    } = this.props;

    const title =
      uiSchema && uiSchema['ui:title']
        ? uiSchema['ui:title']
        : schema.title === undefined ? name : schema.title;

    const expandable = !formContext.expanded;

    const uiProperty = options.childrenTotal
      ? at(schema, `properties.${options.childrenTotal}`)[0]
      : null;
    const property = options.errorCount
      ? at(errorSchema, options.errorCount)[0]
      : null;
    const total = uiProperty ? keys(uiProperty).length : 0;
    const count = total ? total - (property ? keys(property).length : 0) : 0;
    const displayCounts = total > 0 && expandable;

    return (
      <div className={classes.container}>
        <div className={classes.header} onClick={this.onExpand}>
          <Typography color="inherit" className={classes.title}>
            {title}
          </Typography>
          <div className={classes.flex} />
          {displayCounts && (
            <Typography
              type="caption"
              className={classnames({
                [classes.countComplete]: count === total,
              })}
            >
              {count}/{total}
            </Typography>
          )}
          {expandable && (
            <IconButton
              className={classnames(classes.expand, {
                [classes.expandOpen]: this.state.expanded,
              })}
              onClick={this.onExpand}
            >
              <ExpandMoreIcon />
            </IconButton>
          )}
        </div>
        {expandable ? (
          <Collapse in={this.state.expanded} unmountOnExit>
            {children}
          </Collapse>
        ) : (
          children
        )}
      </div>
    );
  }
}

AccordionComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  schema: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object.isRequired,
  name: PropTypes.string,
  options: PropTypes.array,
};

const enhance = compose(
  withProps({
    RootComponent: withStyles(styles)(AccordionComponent),
  })
);

const AccordionField = enhance(BaseObjectField);

export default AccordionField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/AccordionField.js